/* ================================================== */
/* COMPONENTS → Pop aside
/* ================================================== */

$(document).ready(function() {

	$(window).on('scroll', function() {
		if (!breakpointXs) {

			$networkSocialMedia = $('.network__social-media');
			if ($networkSocialMedia.length) {
				if (!$('#layout--header').isInViewport() && !$('#layout--footer').isInViewport()) {
					$networkSocialMedia.addClass('visible');
				} else {
					$networkSocialMedia.removeClass('visible');
				}
			}

			$shortcut = $('.shortcut');
			if ($shortcut.length) {
				if ($(window).scrollTop() > $('#layout--header').outerHeight()/1.5 && !$('#layout--footer').isInViewport()) {
					$shortcut.addClass('visible');
				} else {
					$shortcut.removeClass('visible');
				}
			}

		}
	});

});